export default function ({state, getters, rootState, commit, dispatch}, ) {
    let url = '';
    url = '/tourclient/payment/' + ((state.Id && state.Id !== -1) ? 'update' : 'add');
    let PaymentItem = getters.data;
    if (!PaymentItem) return;
    commit('loading', true);
    axios({
        method: 'post',
        url,
        data: 'request=' + JSON.stringify({PaymentItem})
    }).then(({data}) => {
        commit('loading');
        if (HasError(data, {text: 'Ошибка при сохранении платежа'})) {
            return;
        }
        window.app.$notify.success({
            message: 'Платеж по сертификату сохранен',
        });
        dispatch('certificates/item/reload', {}, {root: true});
        commit('loading');
    }).catch(e => {
        commit('loading');
    });
}